import * as XUI from '../xxeclient/xui.js';
import * as XXE from '../xxeclient/xxeclient.js';
import { XXE_URL_PREFIX } from '../xxeclient/xxeversion.js';

import './wrapper.css';

const XXE_STYLESHEETS = [
    /* 'xuiediticons.css', */
    'xui.css',
    'xxeclient.css',
    'docbook.css',
]

export class XMLEditorWrapper extends HTMLElement {
    
    constructor() {
        super();

        this._toolBar = null;
        this._docView = null;
        this._root = null;
        // this._version = XXE.XMLEditorApp.CLIENT_VERSION;
        this._xxeclient = null;
        this._readOnly = false;
        this.#preConnected();
    }

    #preConnected() {
        // default style
        /*
        this.style.display = 'block';
        this.style.position = 'relative';
        this.style.height = '100%';
        */
    }

    connectedCallback() {
        this._root = this.attachShadow({ mode: "open", delegatesFocus: true });
        this.#addStyleSheets();
        this.#addEditor();
    }

    #addStyleSheets() {
        XUI.Util.setXXEWrapperShadowRoot(this._root);
        XXE_STYLESHEETS.forEach(css => {
            const link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("type", "text/css");
            const url = new URL(XXE_URL_PREFIX + css, window.location.href);
            link.setAttribute("href", url.toString());
            // console.log('Adding link: ' + url.toString());
            this._root.appendChild(link);
        });
    }

    #addEditor() {
        // pass attributes to inner xxeclient
        if (!this.hasAttribute("button2pastestext")) {
            this.button2PastesText = false;
        }
        if (!this.hasAttribute("autoconnect")) {
            this.autoConnect = true;
        }
        if (!this.hasAttribute("autorecover")) {
            this.autoRecover = true;
        }
        if (this.hasAttribute("readonly") ) {
            this.readOnly = true;
        }
        this.serverURL = this.getAttribute("serverurl");
        this._xxeclient = document.createElement("xxe-client");
        this._xxeclient.setAttribute("button2pastestext", this.button2PastesText ? "true" : "false");
        this._xxeclient.setAttribute("autoconnect", this.autoConnect ? "true" : "false");
        this._xxeclient.setAttribute("autorecover", this.autoRecover ? "true" : "false");
        if ( this.serverURL ) {
            this._xxeclient.setAttribute("serverurl", this.serverURL);
        }
        if ( this._readOnly ) {
            this._xxeclient.readOnlyEditor = true;
        }

        this._root.appendChild(this._xxeclient);
        this._docView = this._xxeclient.documentView;
        if ( this._docView ) {
            this._docView.domTree = this._root;
        }
        if ( this._readOnly ) {
            console.log('Setting XMLMind to read only!');
            this._xxeclient.addEventListener("contextmenu", (event) => {
                // console.log('on DocumentView ContextMenu...');
                XUI.Util.consumeEvent(event);
            }, true);
            this._xxeclient.addEventListener("click", (event) => {
                // console.log('on DocumentView ContextMenu...');
                if ( !event.isPrimary ) {
                    XUI.Util.consumeEvent(event);
                }
            }, true);
            this._xxeclient.addEventListener("mousedown", (event) => {
                // console.log('on DocumentView ContextMenu...');
                if ( !event.isPrimary ) {
                    XUI.Util.consumeEvent(event);
                }
            }, true);
            this._xxeclient.addEventListener("mouseup", (event) => {
                // console.log('on DocumentView ContextMenu...');
                if ( !event.isPrimary ) {
                    XUI.Util.consumeEvent(event);
                }
            }, true);
        }
    }

    addEventListener(eventName, handler) {
        this._xxeclient.addEventListener(eventName, handler);
    }

    removeEventListener(eventName, handler) {
        this._xxeclient.removeEventListener(eventName, handler);
    }

    connect() {
        return this._xxeclient.connect();
    }

    disconnect() {
        return this._xxeclient.disconnect();
    }

    getDocument() {
        return this._xxeclient.getDocument();
    }

    openDocument(docContent, docURI, readOnly = false) {
        return this._xxeclient.openDocument(docContent, docURI, readOnly);
    }

    closeDocument(discardChanges = false) {
        return this._xxeclient.closeDocument(discardChanges);
    }

    saveDocument() {
        return this._xxeclient.saveDocument();
    }

    showStatus(text, autoErase = true) {
        this._xxeclient.showStatus(text, autoErase);
    }

    get documentIsOpened() {
        return this._xxeclient.documentIsOpened;
    }

    get uxToolBar() {
        return this._xxeclient.uxToolBar;
    }

    get uxStatusPane() {
        return this._xxeclient.uxStatusPane;
    }

    get xxeClient() {
        return this._xxeclient;
    }

    get documentView() {
        if ( this._docView === null ) {
            this._docView = this._xxeclient.documentView;
            if (this._docView) {
                this._docView.domTree = this._root;
            }
        }
        return this._docView;
    }

    get connected() {
        return this._xxeclient.connected;
    }

    set resourceStorage(storage) {
        if ( this._xxeclient ) {
            this._xxeclient.resourceStorage = storage;
        }
    }

    get button2PastesText() {
        return this.getAttribute("button2pastestext") === "true";
    }

    set button2PastesText(pastes) {
        this.setAttribute("button2pastestext", pastes ? "true" : "false");
        if ( this._xxeclient ) {
            this._xxeclient.button2PastesText = pastes;
        }
        /*
        if (this._docView !== null) {
            this._docView.button2PastesText = pastes;
        }
        */
    }

    get readOnly() {
        return this._readOnly;
    }

    set readOnly(ro) {
        this._readOnly = ro;
    }

    get autoConnect() {
        return this.getAttribute("autoconnect") === "true";
    }

    set autoConnect(connect) {
        this.setAttribute("autoconnect", connect ? "true" : "false");
        if ( this._xxeclient ) {
            this._xxeclient.autoConnect = connect;
        }
    }

    get autoRecover() {
        return this.getAttribute("autorecover") === "true";
    }

    set autoRecover(recover) {
        this.setAttribute("autorecover", recover ? "true" : "false");
        if ( this._xxeclient ) {
            this._xxeclient.autoRecover = recover;
        }
    }

    get serverURL() {
        return this.getAttribute("serverurl");
    }

    set serverURL(url) {
        this.setAttribute("serverurl", url);
    }
}

XMLEditorWrapper.CLIENT_VERSION = XXE.XMLEditorApp.CLIENT_VERSION;

window.customElements.define("ux-xxe-client-wrapper", XMLEditorWrapper);